import axios from 'axios';
import { baseAddress } from '../../tools/baseAddress';

// Updated endpoints to match refactored structure
const addressUploadVideo = baseAddress + 'api/videos/upload';
const addressDeleteVideo = baseAddress + 'api/videos/delete';
const addressGetAllVideos = baseAddress + 'api/videos/list';

export const handleAcousticCsvInputChange = (event, t) => {
  t.setState({
    selectedCsvAcoustic: event.target.files[0],
    formCsvAcoustic: event.target.value,
  });
  return t;
};

export const handleSeismicCsvInputChange = (event, t) => {
  t.setState({
    selectedCsvSeismic: event.target.files[0],
    formCsvSeismic: event.target.value,
  });
  return t;
};

export const handleMagneticCsvInputChange = (event, t) => {
  t.setState({
    selectedCsvMagnetic: event.target.files[0],
    formCsvMagnetic: event.target.value,
  });
  return t;
};

export const handleZipInputChange = (event, t) => {
  t.setState({
    selectedZip: event.target.files[0],
  });
  return t;
};

export const handleVideoInputChange = (event, t) => {
  t.setState({
    selectedVideo: event.target.files[0],
  });
  return t;
};

export const goToAdminPanel = (t) => {
  t.props.history.push('/admin');
};

export const toggleLoadingScreenDisplay = (t, loadingScreenDisplay) => {
  t.setState({
    loadingScreen: loadingScreenDisplay,
  });
  return t.state;
};

export const uploadVideo = (video) => {
  const formData = new FormData();
  formData.append('videoFile', video);
  formData.append('token', localStorage.getItem('token'));

  const config = {
    onUploadProgress: function (progressEvent) {
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
    },
  };

  return axios
    .post(addressUploadVideo, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      ...config,
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.error('Video upload error:', err);
      if (err.response === undefined || err.status === 500) {
        return { data: 'Internal server error! Please try again.' };
      }
      if (err.response.status === 413) {
        return { data: "The file's size cannot exceed 150 MB" };
      }
      return err.response;
    });
};

export const fetchVideoList = () => {
  const formData = new FormData();
  formData.append('token', localStorage.getItem('token'));

  return axios
    .post(addressGetAllVideos, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      
      if (response.data && response.data.videos && Array.isArray(response.data.videos)) {
        response.data.videos = response.data.videos.map(video => {
          let filename = video.split('/').pop();
          
          let base = baseAddress.replace(/\/$/, '');
          
          return `${base}/api/videos/${filename}`;
        });
      }
      
      return response;
    })
    .catch((err) => {
      console.error('Failed to fetch video list:', err);
      if (err.response === undefined || err.status === 500) {
        return { data: 'Internal server error! Please try again.' };
      }
      return err.response;
    });
};

export const deleteVideo = (videoName) => {
  return axios
    .post(addressDeleteVideo, {
      token: localStorage.getItem('token'),
      video_name: videoName,
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.error('Failed to delete video:', err);
      return err.response;
    });
};

  
  